export const SIDE_MENU_CATEGORIES = new Map<number, string>();
SIDE_MENU_CATEGORIES.set(1, 'CREAZIONE PROFILI E COMPETENZE');
SIDE_MENU_CATEGORIES.set(2, 'MODIFICA E APPROVAZIONE PROFILI E COMPETENZE');
SIDE_MENU_CATEGORIES.set(3, 'DECRETAZIONE E CREAZIONE ALLEGATI');
SIDE_MENU_CATEGORIES.set(4, 'ARCHIVIO DATI');
SIDE_MENU_CATEGORIES.set(5, 'GESTIONE UTENZE');


export const SIDE_MENU_ITEM_TO_CATEGORIES = new Map<number, number>();
//* CREAZIONE PROFILI E COMPETENZE
SIDE_MENU_ITEM_TO_CATEGORIES.set(1, 1);
SIDE_MENU_ITEM_TO_CATEGORIES.set(2, 1);

//* MODIFICA E APPROVAZIONE PROFILI E COMPETENZE
SIDE_MENU_ITEM_TO_CATEGORIES.set(7, 2);
SIDE_MENU_ITEM_TO_CATEGORIES.set(8, 2);

//* DECRETAZIONE E CREAZIONE ALLEGATI
SIDE_MENU_ITEM_TO_CATEGORIES.set(9, 3);
SIDE_MENU_ITEM_TO_CATEGORIES.set(10, 3);
SIDE_MENU_ITEM_TO_CATEGORIES.set(12, 3);

//* ARCHIVIO DATI
SIDE_MENU_ITEM_TO_CATEGORIES.set(3, 4);
SIDE_MENU_ITEM_TO_CATEGORIES.set(4, 4);
SIDE_MENU_ITEM_TO_CATEGORIES.set(11, 4);


//* GESTIONE UTENZE
SIDE_MENU_ITEM_TO_CATEGORIES.set(5, 5);
SIDE_MENU_ITEM_TO_CATEGORIES.set(6, 5);

